import $ from 'jquery';
import { EventEmitter } from 'events';

import * as LanguageStore from './../../../stores/language-store';

export class InfoPanelContent extends EventEmitter {
    constructor() {
        super();

        this.container = $('.infoPanel__content__text');
        this.header = $('.infoPanel__content__text h1');
        this.locationContainer = $('.infoPanel__content__text__location');
        this.city = $('.infoPanel__content__text__location__name.city');
        this.country = $('.infoPanel__content__text__location__name.country');
        this.subheader = $('.infoPanel__content__text__desc');
        this.description = $('.infoPanel__content__text__detail');
    }

    update(content) {
        const lang = LanguageStore.get();
        let city,country = '';

        if(lang === 'cn') this.container.addClass('chinese');
        else this.container.removeClass('chinese');


        const header = content['header_' + lang] !== null? content['header_' + lang]: 'unknown';
        const subheader = content['subheader_' + lang] !== null? content['subheader_' + lang]: 'unknown';
        const description = content['description_' + lang] !== null? content['description_' + lang]: 'unknown';

        if(content.type === 'where') {
            this.locationContainer.css('display','block');
            city =  content.location['city_' + lang] + ',';
            country = content.location['country_' + lang];
        }else {
            this.locationContainer.css('display','none');
        }


        this.header.html(header);
        this.city.html(city);
        this.country.html(country);
        this.subheader.html(subheader);
        this.description.html(description);
    }
}
